// frontend/src/pages/ContentPolicy.jsx
import React from "react";
import Screen from "../uizard/ui/Screen";

export default function ContentPolicy() {
  return (
    <Screen>
      <section style={{ maxWidth: 900, padding: '20px' }}>
        <h1 className="h1">Content Policy</h1>
        <p className="lead">
          ArtiBytes is committed to fostering a creative, safe, and respectful community. 
          This policy outlines what content is allowed and what is prohibited on our platform.
        </p>

        <h2 style={{ marginTop: '32px', fontSize: '24px', fontWeight: '700' }}>
          Prohibited Content
        </h2>
        <ul style={{ lineHeight: 1.8, marginBottom: '24px' }}>
          <li><strong>Illegal Content:</strong> No content that violates local, national, or international laws.</li>
          <li><strong>Adult/Sexual Content:</strong> No explicit sexual content, nudity, or sexual content involving minors (zero-tolerance policy).</li>
          <li><strong>Hate Speech & Harassment:</strong> No content promoting hate, discrimination, harassment, or violence based on race, ethnicity, religion, gender, sexual orientation, disability, or other protected characteristics.</li>
          <li><strong>Violence & Gore:</strong> No graphic depictions of violence, gore, or content intended to shock or disturb.</li>
          <li><strong>Intellectual Property Infringement:</strong> Do not generate, upload, or distribute content that infringes on others' copyrights, trademarks, or intellectual property without proper authorization.</li>
          <li><strong>Impersonation:</strong> Do not create content that impersonates real individuals (living or deceased) in a misleading or harmful manner.</li>
          <li><strong>Misinformation:</strong> Do not deliberately create or share false or misleading content, especially related to public safety, politics, or emergencies.</li>
          <li><strong>Spam & Manipulation:</strong> No spam, artificial engagement, or attempts to manipulate platform metrics.</li>
        </ul>

        <h2 style={{ marginTop: '32px', fontSize: '24px', fontWeight: '700' }}>
          Royalty Program Guidelines
        </h2>
        <ul style={{ lineHeight: 1.8, marginBottom: '24px' }}>
          <li>Custom styles must comply with all content policy rules.</li>
          <li>Style names and descriptions must be accurate and not misleading.</li>
          <li>Styles trained on copyrighted material without authorization may be removed.</li>
          <li>Creators are responsible for ensuring their styles don't enable policy violations.</li>
          <li>ArtiBytes reserves the right to remove styles that consistently generate prohibited content.</li>
        </ul>

        <h2 style={{ marginTop: '32px', fontSize: '24px', fontWeight: '700' }}>
          Enforcement
        </h2>
        <p style={{ lineHeight: 1.8, marginBottom: '16px' }}>
          ArtiBytes uses a combination of automated systems and human review to enforce this policy. 
          Violations may result in:
        </p>
        <ul style={{ lineHeight: 1.8, marginBottom: '24px' }}>
          <li>Content removal</li>
          <li>Style deactivation or removal</li>
          <li>Temporary or permanent account suspension</li>
          <li>Loss of Royalty Program eligibility and pending royalties</li>
        </ul>

        <h2 style={{ marginTop: '32px', fontSize: '24px', fontWeight: '700' }}>
          Reporting Violations
        </h2>
        <p style={{ lineHeight: 1.8, marginBottom: '16px' }}>
          If you encounter content that violates this policy, please report it using the report button 
          available on generated images. All reports are reviewed promptly and confidentially.
        </p>

        <h2 style={{ marginTop: '32px', fontSize: '24px', fontWeight: '700' }}>
          Appeals
        </h2>
        <p style={{ lineHeight: 1.8, marginBottom: '24px' }}>
          If you believe your content or account was restricted in error, you may submit an appeal 
          by contacting support with details about the decision you're appealing.
        </p>

        <p style={{ color: "#6b7280", fontStyle: 'italic', marginTop: '32px', paddingTop: '24px', borderTop: '1px solid #e5e7eb' }}>
          This policy may be updated periodically. Continued use of ArtiBytes constitutes acceptance 
          of the current Content Policy. Last updated: January 2026.
        </p>
      </section>
    </Screen>
  );
}